/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 24/11/2013
 * Time: 15:53
 * To change this template use File | Settings | File Templates.
 */


angular.module('FlexyBeautyApp.services').
    factory('Day_Resource',["$resource","$location", function ($resource,$location)
    {
        var baseUrl = $location.protocol()  + "://" + $location.host() + ($location.port() && ":" + $location.port())  + "/";
        return  $resource(baseUrl+'rest/days/:id',{}, {
            query: { method: 'GET', isArray: false },
            get:   { method: 'GET' } ,
            getDays : {method: 'GET',url:baseUrl+'rest/days/:startId/:endId',isArray: false},
            getAvailablePeriods : {method: 'GET',url:baseUrl+'rest/days/availablePeriods/v2/:startId/:endId/:isNextWeek',isArray: false, cancellable: true},
            listDaysId : {method: 'GET',url:baseUrl+'rest/days/listDaysId',isArray: true},
        });
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('Day',["Day_Resource","DayHr","DayHrData","DayPr","DayPrData","Booking","BookingData","SaleData","Sale","SiteData","HumanResourceData","moment",
            "PosOp","PosOpData","Closure","TypeOfSale", "Category","Service","RootStatCategorie","ProductCategory","CureCategory","LoyaltyCardCategory",
            "Product","Cure","LoyaltyCard","HrRootOccupationRateCategory","PrRootOccupationRateCategory","PhysicalResourceData","HumanResource", "HrRootCategory",
            "NbCustormerCategoryStat","TypeOfBooking","TaxMode","GiftItemRootCategory","TypeOfCustomer","VatData","LoyaltyCustomers","BookingService","PhysicalResource",
            "GiftItemByHrRootCategory","HumanResourceExtra","HrOccupationDatas","WorkingTimeRootCategory", "WorkingTimeHrIndisponibilityTime", "WorkingTimeHrUsualIndisponibilityTime",
            "WorkingTimeHrUnusualIndisponibilityTime", "WorkingTimeHrBookingOpenTime", "WorkingTimeHrUnoccupiedTime", "WorkingTimeHrBookingTime","TypeOfCustomerRootCategory", "ProductStatCategorie",
        function (Day_Resource,DayHr,DayHrData,DayPr,DayPrData,Booking,BookingData,SaleData,Sale,SiteData,HumanResourceData,moment,
                  PosOp,PosOpData,Closure,TypeOfSale,Category,Service,RootStatCategorie, ProductCategory, CureCategory,LoyaltyCardCategory,
                  Product,Cure,LoyaltyCard,HrRootOccupationRateCategory,PrRootOccupationRateCategory,PhysicalResourceData,HumanResource,HrRootCategory,
                  NbCustormerCategoryStat,TypeOfBooking,TaxMode,GiftItemRootCategory,TypeOfCustomer,VatData,LoyaltyCustomers,BookingService,PhysicalResource,
                  GiftItemByHrRootCategory,HumanResourceExtra,HrOccupationDatas,WorkingTimeRootCategory,WorkingTimeHrIndisponibilityTime,WorkingTimeHrUsualIndisponibilityTime,
                  WorkingTimeHrUnusualIndisponibilityTime,WorkingTimeHrBookingOpenTime,WorkingTimeHrUnoccupiedTime,WorkingTimeHrBookingTime,TypeOfCustomerRootCategory, ProductStatCategorie)
    {
        //Day inherit of $resource

        var  Day = function (resource, isApplicationLoading)
        {
            // Call the parent constructor
            this.id = null;
            this.bookings = [];
            this.sales = [];
            this.dayHrs = [];
            this.dayPrs = [];
            this.posOps = [];
            this.closure = null;
            this.precalculatedSaleStatDatas = [];
            this.precalculatedBookingStatDatas = [];
            this.precalculatedHrOccupationDatas = [];
            this.precalculatedPrOccupationDatas = [];

            if (resource!==undefined && resource!=null)
            {
                this.loadObject(resource, isApplicationLoading);
            }
        };
        Day.prototype.loadObject = function(object, isApplicationLoading)
        {
            if (!this.id)
                this.id = object.id;
            var booking;
            if (object.bookings) //load booking in first (will be used by DayHr to set bookingService)
            {

                this.bookings = [];
                for (var i = 0; i < object.bookings.length; i++) {
                    booking = BookingData.getById(object.bookings[i].id, isApplicationLoading);
                    if (!booking)
                        booking = new Booking(object.bookings[i], this, true, null, isApplicationLoading);
                    else
                        booking.loadObject(object.bookings[i], isApplicationLoading);
                    this.bookings.push(booking);

                }
            }
            var sale;
            if (object.sales) //load sale in first (will be used by DayHr to set saleService)
            {

                this.sales = [];
                for (var i = 0; i < object.sales.length; i++) {
                    sale = SaleData.getById(object.sales[i].id, isApplicationLoading);
                    if (!sale)
                        sale = new Sale(object.sales[i], this, true, null, isApplicationLoading);
                    else
                        sale.loadObject(object.sales[i], isApplicationLoading);
                    this.sales.push(sale);

                }
            }

            if (object.dayHrs)
            {
                this.dayHrs = [];
                var dayHr;
                for (var j =0;j< object.dayHrs.length;j++)
                {
                    dayHr = null;
                    if (object.dayHrs[j].id)
                        dayHr = DayHrData.getById(object.dayHrs[j].id);
                    if (!dayHr)
                        dayHr = new DayHr(object.dayHrs[j],this, null, isApplicationLoading);
                    else
                        dayHr.loadObject(object.dayHrs[j], isApplicationLoading);
                    this.dayHrs.push(dayHr);

                }
            }
            if (object.dayPrs)
            {
                this.dayPrs = [];
                var dayPr;
                for (var j =0;j< object.dayPrs.length;j++)
                {
                    dayPr = null;
                    if (object.dayPrs[j].id)
                        dayPr = DayPrData.getById(object.dayPrs[j].id);
                    if (!dayPr)
                        dayPr = new DayPr(object.dayPrs[j],this, null, isApplicationLoading);
                    else
                        dayPr.loadObject(object.dayPrs[j], isApplicationLoading);
                    this.dayPrs.push(dayPr);

                }
            }
            if (object.posOps) //load booking in first (will be used by DayHr to set bookingService)
            {

                this.posOps = [];
                for (var i = 0; i < object.posOps.length; i++) {
                    var posOp = PosOpData.getById(object.posOps[i].id);
                    if (!posOp)
                        posOp = new PosOp(object.posOps[i], this);
                    else
                        posOp.loadObject(object.posOps[i]);
                    this.posOps.push(posOp);

                }
            }
            if (object.closure)
                this.closure = new Closure(object.closure,this);
        };
        Day.prototype.getBooking = function(id)
        {
            for (var i=0;i<this.bookings.length;i++)
                if (this.bookings[i].id == id)
                    return this.bookings[i];
            return null;
        };
        Day.prototype.getBookingByCustomerId = function(customerId)
        {
            for (var i=0;i<this.bookings.length;i++)
                if (this.bookings[i].customer && this.bookings[i].customer.id == customerId)
                    return this.bookings[i];
            return null;
        };
        Day.prototype.getIndexOfDayHr = function(humanResourceId)
        {
            if (this.dayHrs)
                for (var i =0;i< this.dayHrs.length;i++)
                    if(this.dayHrs[i].humanResourceId==humanResourceId)
                        return i;
            return -1;
        };
        Day.prototype.getIndexOfDayPr = function(physicalResourceId,prUnitId)
        {
            if (this.dayHrs)
                for (var i =0;i< this.dayHrs.length;i++)
                    if(this.dayHrs[i].physicalResourceId==physicalResourceId && this.dayHrs[i].prUnitId==prUnitId)
                        return i;
            return -1;
        };
        Day.prototype.getDayHrByHrId = function(humanResourceId)
        {
            if (this.dayHrs)
                for (var i =0;i< this.dayHrs.length;i++)
                    if(this.dayHrs[i].humanResourceId==humanResourceId)
                        return this.dayHrs[i];
            return null;
        };
        Day.prototype.getDayPrByPrId = function(physicalResourceId, prUnitId)
        {
            if (this.dayPrs)
                for (var i = 0;i < this.dayPrs.length;i++)
                    if(this.dayPrs[i].physicalResourceId==physicalResourceId && this.dayPrs[i].prUnitId==prUnitId)
                        return this.dayPrs[i];
            return null;
        };
        Day.prototype.createAndAddDayHr = function(humanResourceId)
        {
            var dayHr =null;
            if (this.getIndexOfDayHr(humanResourceId)==-1)
            {
                dayHr = new DayHr(null,this);
                dayHr.humanResourceId = humanResourceId;
                this.dayHrs.push(dayHr);
            }
            return dayHr;
        };
        Day.prototype.addDayHr = function(dayHr)
        {
            if (this.dayHrs.indexOf(dayHr)==-1)
            {
                this.dayHrs.push(dayHr);
                dayHr.day = this;
            }
            return dayHr;
        };
        Day.prototype.removeDayHr = function(dayHr)
        {
            var index = this.dayHrs.indexOf(dayHr);
            if (index!=-1)
            {
                this.dayHrs.splice(index,1);
                dayHr.day = null;
            }
        };
        Day.prototype.createAndAddDayPr = function(physicalResourceId,prUnitId)
        {
            var dayPr =null;
            if (this.getIndexOfDayPr(physicalResourceId,prUnitId)==-1)
            {
                dayPr = new DayPr(null,this);
                dayPr.physicalResourceId = physicalResourceId;
                dayPr.prUnitId = prUnitId;
                this.dayPrs.push(dayPr);
            }
            return dayPr;
        };
        Day.prototype.addDayPr = function(dayPr)
        {
            if (this.dayPrs.indexOf(dayPr)==-1)
            {
                this.dayPrs.push(dayPr);
                dayPr.day = this;
            }
            return dayPr;
        };
        Day.prototype.removeDayPr = function(dayPr)
        {
            var index = this.dayPrs.indexOf(dayPr);
            if (index!=-1)
            {
                this.dayPrs.splice(index,1);
                dayPr.day = null;
            }
        };
        Day.prototype.getBookingServiceById = function(bsId)
        {
            var bs = null;
            if (this.bookings)
                for (var i =0;i< this.bookings.length;i++)
                {
                    bs = this.bookings[i].getBookingServiceById(bsId);
                    if (bs)
                        return bs;
                }
            return bs;
        };
        Day.prototype.addBooking = function(booking)
        {
            var index = this.bookings.indexOf(booking)
            if (index==-1)
            {
                this.bookings.push(booking)
                booking.day = this;
            }
        };
        Day.prototype.removeBooking = function(booking)
        {
            var index = this.bookings.indexOf(booking)
            if (index!=-1)
                this.bookings.splice(index,1);
        };
        Day.prototype.addSale = function(sale)
        {
            var index = this.sales.indexOf(sale)
            if (index==-1)
            {
                this.sales.push(sale)
                sale.day = this;
            }
        };
        Day.prototype.removeSale = function(sale)
        {
            var index = this.sales.indexOf(sale)
            if (index!=-1)
                this.sales.splice(index,1);
        };
        Day.prototype.addPosOp = function(posOp)
        {
            var index = this.posOps.indexOf(posOp)
            if (index==-1)
            {
                this.posOps.push(posOp)
                posOp.day = this;
            }
        };
        Day.prototype.removePosOp = function(posOp)
        {
            var index = this.posOps.indexOf(posOp)
            if (index!=-1)
                this.posOps.splice(index,1);
        };
        Day.prototype.getDayOfWIndex = function()
        {
            var date = this.getDate();
            if (date) {
                var dayOfWIndex = date.getDay() - 1;  //0=Sun, 1=Mon, ..., 6=Sat
                if (dayOfWIndex == -1)
                    dayOfWIndex = 6;
                return dayOfWIndex;
            }
            else
                return null;
        };

        Day.prototype.isOpen = function()
        {
            // allow to know if at least on hr is working
            var humanRessources = HumanResourceData.getActiveList();
            var isOpen = false;
            for (var i=0;i<humanRessources.length && !isOpen;i++)
                isOpen =  humanRessources[i].hasPlanning && this.hrIsWorking(humanRessources[i].id);

            var physicalRessources = PhysicalResourceData.getActiveList();
            for (var i=0;i<physicalRessources.length && !isOpen;i++)
                if (physicalRessources[i].hasPlanning)
                    for (var u=1;u<=physicalRessources[i].number && !isOpen;u++)
                        isOpen =  this.prIsWorking(physicalRessources[i].id,u);
            return isOpen;
        };

        Day.prototype.isAStatisticDay = function(object)
        {
            var isAStatisticDay = (this.isOpen() || this.sales.length != 0 || this.bookings.length != 0);

            if(object instanceof HumanResource){
                isAStatisticDay = (day.getHrWorkingTime() > 0);
            }
            return isAStatisticDay;
        };

        Day.prototype.hrIsWorking = function(hrId)
        {
            // allow to know if hr is working by hrid
            //check default site data
            var hrIsWorking = false;
            var dayHr = this.getDayHrByHrId(hrId);
            if (dayHr && dayHr.hasSpecificWpPeriods)
                hrIsWorking = (dayHr.periods!=null && dayHr.periods.length!=0) || (dayHr.hasBookingActivities());
            else
                hrIsWorking = SiteData.defaultSite.hrIsWorking(this.getDayOfWIndex(),hrId);
            return hrIsWorking;
        };

        Day.prototype.prIsWorking = function(prId, prUnitId)
        {
            // allow to know if pr is working by prid
            //check default site data
            var prIsWorking = false,
                dayPr = this.getDayPrByPrId(prId, prUnitId);

            if (dayPr && dayPr.hasSpecificWpPeriods)
                prIsWorking = (dayPr.periods != null && dayPr.periods.length != 0) || (dayPr.hasBookingActivities());
            else
                prIsWorking = SiteData.defaultSite.prIsWorking(this.getDayOfWIndex(), prId,prUnitId);

            return prIsWorking;
        };

        Day.prototype.getHrWorkingTime = function(hrId)
        {
            // allow to get hr workingTime by hrid
            //check default site data if no specific period
            var hrWorkingTime = 0;
            var dayHr = this.getDayHrByHrId(hrId),
                hrWpDays = this.getHrWpDays(hrId);

            if (dayHr && dayHr.hasSpecificWpPeriods)
                hrWorkingTime = dayHr.getHrWorkingTime();
            else
                hrWorkingTime = SiteData.defaultSite.getHrWorkingTime(this.getDayOfWIndex(),hrId);

            if (dayHr && hrWorkingTime > 0) {
                for (var i = 0; i < dayHr.activities.length; i++) {
                    if (!(dayHr.activities[i] instanceof BookingService) && dayHr.activities[i].period && dayHr.activities[i].period.duration) {
                        hrWorkingTime -= dayHr.activities[i].period.duration;
                    }
                }
            }
            if (hrWpDays && hrWorkingTime > 0) {
                for(var i = 0 ; i < hrWpDays.length; i++) {
                    if(hrWpDays[i].workingPeriodDay && hrWpDays[i].workingPeriodDay.openDay) {
                        for (var j = 0; j < hrWpDays[i].activities.length; j++) {
                            if (!(hrWpDays[i].activities[j] instanceof BookingService) && hrWpDays[i].activities[j].period && hrWpDays[i].activities[j].period.duration) {
                                hrWorkingTime -= hrWpDays[i].activities[j].period.duration;
                            }
                        }
                    }
                }
            }
            return hrWorkingTime > 0 ? hrWorkingTime:0;
        };
        Day.prototype.getHrUnusualIndisponibilityTime = function(hrId)
        {
            // allow to get hr workingTime by hrid
            //check default site data if no specific period
            var hrIndisponibilityTime = 0;
            var dayHr = this.getDayHrByHrId(hrId),
                hrWpDays = this.getHrWpDays(hrId);

            if (dayHr) {
                for (var i = 0; i < dayHr.activities.length; i++) {
                    if (!(dayHr.activities[i] instanceof BookingService) && dayHr.activities[i].period && dayHr.activities[i].period.duration) {
                        hrIndisponibilityTime += dayHr.activities[i].period.duration;
                    }
                }
            }
            return hrIndisponibilityTime;
        };

        Day.prototype.getHrUsualIndisponibilityTime = function(hrId)
        {
            // allow to get hr workingTime by hrid
            //check default site data if no specific period
            var hrIndisponibilityTime = 0;
            var hrWpDays = this.getHrWpDays(hrId);

            if (hrWpDays) {
                for(var i = 0 ; i < hrWpDays.length; i++) {
                    if(hrWpDays[i].workingPeriodDay && hrWpDays[i].workingPeriodDay.openDay) {
                        for (var j = 0; j < hrWpDays[i].activities.length; j++) {
                            if (!(hrWpDays[i].activities[j] instanceof BookingService) && hrWpDays[i].activities[j].period && hrWpDays[i].activities[j].period.duration) {
                                hrIndisponibilityTime += hrWpDays[i].activities[j].period.duration;
                            }
                        }
                    }
                }
            }
            return hrIndisponibilityTime;
        };

        Day.prototype.getPrWorkingTime = function(prId,prUnitId)
        {
            // allow to get pr workingTime by prid
            //check default site data if no specific period
            var prWorkingTime = 0;
            var dayPr = this.getDayPrByPrId(prId, prUnitId);
            if (dayPr && dayPr.hasSpecificWpPeriods)
                prWorkingTime = dayPr.getPrWorkingTime();
            else
                prWorkingTime = SiteData.defaultSite.getPrWorkingTime(this.getDayOfWIndex(),prId,prUnitId);

            if (dayPr) {
                for (var i = 0; i < dayPr.activities.length; i++) {
                    if (!(dayPr.activities[i] instanceof BookingService) && dayPr.activities[i].period && dayPr.activities[i].period.duration) {
                        prWorkingTime -= dayPr.activities[i].period.duration;
                    }
                }
            }

            return prWorkingTime;
        };
        Day.prototype.getNbWorkers = function() {
            var humanRessources = HumanResourceData.getActiveList();
            var nbWorkers = 0;
            for(var i = 0;i < humanRessources.length;i ++ ){
                if(this.getHrWorkingTime(humanRessources[i].id) != 0 && humanRessources[i].hasPlanning) {
                    nbWorkers++;
                }
            }
            return nbWorkers;
        };
        Day.prototype.getNbWorkingHrDay = function() {
            var humanRessources = HumanResourceData.getActiveList();
            var nbJWorkingHr = 0;
            for(var i = 0;i < humanRessources.length;i ++ ){
                if(this.getWorkingTime() != 0) {
                    nbJWorkingHr += this.getHrWorkingTime(humanRessources[i].id) / this.getWorkingTime();
                }
            }
            return nbJWorkingHr;
        };
        Day.prototype.getWorkingTime = function() {
            var timeWorking = 0;
            for(var i = 0; i < this.getWpDays().length; i++){
                if(this.getWpDays()[i].workingPeriod && this.getWpDays()[i].workingPeriod.period && this.getWpDays()[i].workingPeriod.period.duration) {
                    timeWorking += this.getWpDays()[i].workingPeriod.period.duration;
                }
            }
            return timeWorking;
        };
        Day.prototype.getWpDays = function()
        {
            // allow to get site.wp.wpday for hr id
            return  SiteData.defaultSite.getWpDays(this.getDayOfWIndex());
        };
        Day.prototype.getHrWpDays = function(humanResourceId)
        {
            var wpDay = this.getWpDays(),
                hrWpDays = new Array();
            if(wpDay){
                for(var i = 0; i < wpDay.length; i++){
                    var hrWpDay = wpDay[i].getWorkingPeriodDayHr(humanResourceId);
                    if(hrWpDay)
                        hrWpDays.push(hrWpDay);
                }
            }
            // allow to get site.wp.wpday for hr id
            return hrWpDays;
        };

        Day.prototype.getHrBookingTime = function(hrId)
        {
            // allow to get hr bookingTime by hrid
            var hrBookingTime = 0;
            var dayHr = this.getDayHrByHrId(hrId);
            if (dayHr)
                hrBookingTime = dayHr.getHrBookingTime();
            return hrBookingTime;
        };
        Day.prototype.getPrBookingTime = function(prId,prUnitId)
        {
            // allow to get pr bookingTime by prid
            var prBookingTime = 0;
            var dayPr = this.getDayPrByPrId(prId, prUnitId);
            if (dayPr)
                prBookingTime = dayPr.getPrBookingTime();
            return prBookingTime;
        };

        Day.prototype.clearPrecalculatedStatDatas = function()
        {
            this.precalculatedSaleStatDatas = [];
            this.precalculatedBookingStatDatas = [];
            this.precalculatedHrOccupationDatas = [];
            this.precalculatedPrOccupationDatas = [];
        };

        Day.prototype.getKeyOfSaleObjects = function(saleObjects, additionalFilters, firstDayOfPeriod, taxMode)
        {
            let key = "";
            for(let i = 0 ; i < saleObjects.length; i++){
                key = key + (i != 0 ?";":"") + saleObjects[i].id;
            }
            if(key.length > 0) {
                key = key + (saleObjects.length > 0 != 0 ? ";" : "");
            }

            for(let i = 0 ; i < additionalFilters.length; i++){
                key = key + (i != 0 ?";":"") + additionalFilters[i].id;
            }

            if(key.length > 0) {
                key = key + (additionalFilters.length > 0 ? ";" : "");
            }

            key = key + (taxMode?(";" + taxMode.id):"") +( (firstDayOfPeriod && firstDayOfPeriod.id)? (";" + firstDayOfPeriod.id):"");
            return key;
        };

        Day.prototype.getAverageSalesCaByWorkerOfSaleObject = function(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode)
        {
            let averageSalesCaByWorker = 0;
            if (this.getNbWorkers() !== 0) {
                averageSalesCaByWorker = (this.getSalesCaOfSaleObject(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode) / this.getNbWorkers());
            }
            return averageSalesCaByWorker;
        };

        Day.prototype.getAverageNbSalesByWorkerOfSaleObject = function(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode)
        {
            let averageNbSalesByWorker = 0;
            if (this.getNbWorkers() !== 0) {
                averageNbSalesByWorker = (this.getNbSalesOfSaleObject(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode) / this.getNbWorkers());
            }
            return averageNbSalesByWorker;
        };

        Day.prototype.getAverageNbSubSalesByWorkerOfSaleObject = function(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode)
        {
            let averageNbSalesByWorker = 0;
            if (this.getNbWorkers() !== 0) {
                averageNbSalesByWorker = (this.getNbSubSalesOfSaleObject(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode) / this.getNbWorkers());
            }
            return averageNbSalesByWorker;
        };

        Day.prototype.getNbSubSalesOfSaleObject = function(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode)
        {
            return this.getSalesDatasOfSaleObject(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode).qteSubSales;
        };

        Day.prototype.getSubSalesStepOfSaleObject = function(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode)
        {
            return this.getSalesDatasOfSaleObject(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode).subSalesStep;
        };

        Day.prototype.getSubSalesOfSaleObject = function(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode)
        {
            return this.getSalesDatasOfSaleObject(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode).subSales;
        };

        Day.prototype.getNbSalesOfSaleObject = function(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode)
        {
            return this.getSalesDatasOfSaleObject(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode).qteSales;
        };

        Day.prototype.getNbSoldSalesOfSaleObject = function(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode)
        {
            return this.getSalesDatasOfSaleObject(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode).qteSalesSold;
        };

        Day.prototype.getNbSalesWithServiceOrProduct = function(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode){
            return this.getNbSalesOfSaleObject([TypeOfSale.ALL_WITH_PRODUCT_OR_NOT],additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode);
        };

        Day.prototype.getSalesOfSaleObject = function(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode)
        {
            return this.getSalesDatasOfSaleObject(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode).sales;
        };

        Day.prototype.getVisitsOfSaleObject = function(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode)
        {

            let salesData = this.getSalesDatasOfSaleObject(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode),
                bookings = this.getBookingDatasOfBookingObject(saleObjects, additionalFilters, firstDayOfPeriod, taxMode).bookings,
                visits = [];

            for(let i = 0 ; i < bookings.length; i++){
                let minBooking = {
                    date : bookings[i].day?bookings[i].day.getDate():"",
                    isBooking : true,
                    bookingTime : bookings[i].period.start.getLabel(),
                    status : bookings[i].status,
                    items : [],
                    customer : bookings[i].customer,
                    price : bookings[i].price,
                    unpaid : (!bookings[i].sale),
                    dataType : 'VISITE'
                };

                for(let j = 0; j < bookings[i].bookingServices.length; j ++){
                    minBooking.items.push({
                        type: "service",
                        label : bookings[i].bookingServices[j].label
                    });
                }
                visits.push(minBooking);
            }

            for(let i = 0 ; i < salesData.salesWithBookingOutOfPeriod.length; i++){
                let minSale = {
                    date : salesData.salesWithBookingOutOfPeriod[i].day?salesData.salesWithBookingOutOfPeriod[i].day.getDate():"",
                    isBooking : false,
                    bookingTime : null,
                    status : salesData.salesWithBookingOutOfPeriod[i].status,
                    items : [],
                    customer : salesData.salesWithBookingOutOfPeriod[i].customer,
                    price : salesData.salesWithBookingOutOfPeriod[i].price,
                    unpaid : false,
                    dataType : 'VISITE'
                };

                for(let j = 0; j < salesData.salesWithBookingOutOfPeriod[i].saleServices.length; j ++){
                    minSale.items.push({
                        type: "service",
                        label : salesData.salesWithBookingOutOfPeriod[i].saleServices[j].label
                    });
                }

                for(let j = 0; j < salesData.salesWithBookingOutOfPeriod[i].saleProducts.length; j ++){
                    minSale.items.push({
                        type: "product",
                        label : salesData.salesWithBookingOutOfPeriod[i].saleProducts[j].label
                    });
                }

                for(let j = 0; j < salesData.salesWithBookingOutOfPeriod[i].saleCures.length; j ++){
                    minSale.items.push({
                        type: "cure",
                        label : salesData.salesWithBookingOutOfPeriod[i].saleCures[j].label
                    });
                }

                visits.push(minSale);
            }
            for(let i = 0 ; i < salesData.salesWithoutBooking.length; i++){
                let minSale = {
                    date : salesData.salesWithoutBooking[i].day?salesData.salesWithoutBooking[i].day.getDate():"",
                    isBooking : false,
                    bookingTime : null,
                    status : salesData.salesWithoutBooking[i].status,
                    items : [],
                    customer : salesData.salesWithoutBooking[i].customer,
                    price : salesData.salesWithoutBooking[i].price,
                    unpaid : false,
                    dataType : 'VISITE'
                };

                for(let j = 0; j < salesData.salesWithoutBooking[i].saleServices.length; j ++){
                    minSale.items.push({
                        type: "service",
                        label : salesData.salesWithoutBooking[i].saleServices[j].label
                    });
                }

                for(let j = 0; j < salesData.salesWithoutBooking[i].saleProducts.length; j ++){
                    minSale.items.push({
                        type: "product",
                        label : salesData.salesWithoutBooking[i].saleProducts[j].label
                    });
                }

                for(let j = 0; j < salesData.salesWithoutBooking[i].saleCures.length; j ++){
                    minSale.items.push({
                        type: "cure",
                        label : salesData.salesWithoutBooking[i].saleCures[j].label
                    });
                }

                visits.push(minSale);
            }

            return visits;
        };

        Day.prototype.getNbSoldSalesWithoutGift = function(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode)
        {
            return this.getSalesDatasOfSaleObject(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode).nbSalesWithoutGift;
        };

        Day.prototype.getNbSalesWithGift = function(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode)
        {
            return this.getSalesDatasOfSaleObject(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode).nbSalesWithGift;
        };

        Day.prototype.getSalesCaOfSaleObject = function(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode){
            let price = this.getSalesDatasOfSaleObject(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode).price;
            price = price === null ? 0 : price;
            return price;
        };
        Day.prototype.getSalesCaTotal = function(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode){
            let price =  this.getSalesDatasOfSaleObject([RootStatCategorie], additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode).price;
            price = price === null ? 0 : price;
            return price
        };
        Day.prototype.getNbSalesTotal = function(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode){
            return this.getNbSalesOfSaleObject([RootStatCategorie], additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode);
        };

        Day.prototype.getNbSubSalesOldCustomerOfSaleObject = function(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode)
        {
            return this.getSalesDatasOfSaleObject(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode).qteSubSalesOldCustomer;
        };

        Day.prototype.getSubSalesOldCustomerOfSaleObject = function(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode)
        {
            return this.getSalesDatasOfSaleObject(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode).subSalesOldCustomer;
        };

        Day.prototype.getNbSubSalesNewCustomerOfSaleObject = function(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode)
        {
            return this.getSalesDatasOfSaleObject(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode).qteSubSalesNewCustomer;
        };

        Day.prototype.getSubSalesNewCustomerOfSaleObject = function(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode)
        {
            return this.getSalesDatasOfSaleObject(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode).subSalesNewCustomer;
        };

        Day.prototype.getDurationOfSaleObject = function(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode)
        {
            return (this.getSalesDatasOfSaleObject(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode).duration / 60);
        };

        Day.prototype.getSalesDatasOfSaleObject = function(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode)
        {
            let salesDatas = null,
                keyOfSaleObjects = this.getKeyOfSaleObjects(saleObjects, additionalFilters, firstDayOfPeriod, taxMode);

            if(this.precalculatedSaleStatDatas[keyOfSaleObjects] !== undefined && moment().startOf('day').isAfter(this.getMomentDate())){
                salesDatas = this.precalculatedSaleStatDatas[keyOfSaleObjects];
            }
            else {
                salesDatas = {
                    price : 0,
                    sales : [],
                    salesWithoutBooking : [],
                    salesWithBookingOutOfPeriod : [],
                    qteSubSalesWithoutBooking : 0,
                    subSalesWithoutBooking : [],
                    subSalesWithBookingOutOfPeriod : [],
                    qteSubSalesWithBookingOutOfPeriod : 0,
                    subSales : [],
                    subSalesStep : [],
                    salesNewCustomer : [],
                    salesOldCustomer : [],
                    subSalesNewCustomer : [],
                    subSalesOldCustomer : [],
                    qteSales : 0,
                    qteSalesSold : 0,
                    qteSubSales : 0,
                    qteSubSalesNewCustomer : 0,
                    qteSubSalesOldCustomer : 0,
                    duration : 0,
                    customers : [],
                    customersFirstVisit : [],
                    customersSales : [],
                    customersFirstSales : [],
                    customersFirstSalesOfSaleObject : [],
                    nbCustomers : 0,
                    loyaltyCustormers : [],
                    matchedSalesOfPassageCustomer : [],
                    nbPassageCustomersOfSaleWithoutBooking : 0,
                    nbPassageCustomersOfSaleWithBooking : 0,
                    humanRessource : null,
                    nbSalesWithoutGift : 0,
                    nbSalesWithGift : 0
                };

                for (let i = 0; i < this.sales.length; i++) {
                    if (this.sales[i].status === "sold" || this.sales[i].status === 'canceled' || this.sales[i].status === 'credit') {
                        for (let j = 0; j < this.sales[i].saleServices.length; j++) {
                            if(this.sales[i].saleServices[j].isPriceCalculatedBySubSaleServices()){
                                for (let k = 0; k < this.sales[i].saleServices[j].subSaleServices.length; k++) {
                                    this.sales[i].saleServices[j].subSaleServices[k].incrementSalesDatas(salesDatas, saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode, this);
                                }
                            }
                            else{
                                this.sales[i].saleServices[j].incrementSalesDatas(salesDatas, saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode, this);
                            }
                        }
                        for (let j = 0; j < this.sales[i].saleProducts.length; j++) {
                            this.sales[i].saleProducts[j].incrementSalesDatas(salesDatas, saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode, this);
                        }

                        for (let j = 0; j < this.sales[i].saleCures.length; j++) {
                            this.sales[i].saleCures[j].incrementSalesDatas(salesDatas, saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode, this);
                        }

                        for (let j = 0; j < this.sales[i].loyaltyCardItems.length; j++) {
                            this.sales[i].loyaltyCardItems[j].incrementSalesDatas(salesDatas, saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode, this);
                        }

                        for (let j = 0; j < this.sales[i].giftItems.length; j++) {
                            this.sales[i].giftItems[j].incrementSalesDatas(salesDatas, saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode, this);
                        }

                        if((this.sales[i].saleProducts.length > 0 || this.sales[i].saleServices.length > 0 || this.sales[i].saleCures.length > 0 ||  this.sales[i].loyaltyCardItems.length > 0) && this.sales[i].giftItems.length === 0){
                            salesDatas.nbSalesWithoutGift += (this.sales[i].status === 'credit' ? -1 : 1);
                        }

                        if(this.sales[i].giftItems.length !== 0){
                            salesDatas.nbSalesWithGift += (this.sales[i].status === 'credit' ? -1 : 1);
                        }
                    }
                }
                for(let i = 0; i < salesDatas.matchedSalesOfPassageCustomer.length; i++){
                    if (!salesDatas.matchedSalesOfPassageCustomer[i].isCancelledOrCredit()) {
                        salesDatas.nbCustomers++;

                        if(salesDatas.matchedSalesOfPassageCustomer[i].booking){
                            salesDatas.nbPassageCustomersOfSaleWithBooking++;
                        }
                        else{
                            salesDatas.nbPassageCustomersOfSaleWithoutBooking++;
                        }
                    }
                }
                this.precalculatedSaleStatDatas[keyOfSaleObjects] = salesDatas;
            }
            return salesDatas;
        };

        Day.prototype.getNbSubVisitsOfSaleObject = function(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode)
        {
            let salesData = this.getSalesDatasOfSaleObject(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode),
                subBookings = this.getBookingDatasOfBookingObject(saleObjects, additionalFilters, firstDayOfPeriod, taxMode).subBookings;

            return subBookings.length + salesData.qteSubSalesWithoutBooking + salesData.qteSubSalesWithBookingOutOfPeriod;
        };


        Day.prototype.getNbVisitsOfSaleObject = function(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode)
        {
            let salesData = this.getSalesDatasOfSaleObject(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode),
                bookings = this.getBookingDatasOfBookingObject(saleObjects, additionalFilters, firstDayOfPeriod, taxMode).bookings,
                nbBookings = (bookings && bookings.length)?  bookings.length : 0,
                nbSalesWithBookingOutOfPeriod = (salesData.salesWithBookingOutOfPeriod && salesData.salesWithBookingOutOfPeriod.length)?  salesData.salesWithBookingOutOfPeriod.length : 0,
                nbSalesWithoutBooking = (salesData.salesWithoutBooking && salesData.salesWithoutBooking.length) ?  salesData.salesWithoutBooking.length : 0;

            return nbBookings + nbSalesWithBookingOutOfPeriod + nbSalesWithoutBooking;
        };

        Day.prototype.getNbFirstCustomersOfSaleObject = function(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode)
        {
            let saleDatas = this.getSalesDatasOfSaleObject(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode),
                bookingsDatas = this.getBookingDatasOfBookingObject(saleObjects, additionalFilters, firstDayOfPeriod, taxMode),
                customerFomSales = saleDatas.customersFirstSalesOfSaleObject,


                customersFromBooking = bookingsDatas.customersFirstBookingsOfBookingObject,
                passageCustomersSale = saleDatas.nbPassageCustomersOfSaleWithoutBooking + saleDatas.nbPassageCustomersOfSaleWithBooking,
                passageCustomersBookingWithoutsale =  bookingsDatas.nbPassageCustomersOfBookingWithoutSale,
                nbCustomers = 0,
                customers = [];

            for(let i = 0; i < customerFomSales.length; i++ ) {
                if (customers.indexOf(customerFomSales[i]) === -1) {
                    customers.push(customerFomSales[i]);
                    nbCustomers++;
                }
            }
            for(let i = 0; i < customersFromBooking.length; i++ ) {
                if (customers.indexOf(customersFromBooking[i]) === -1) {
                    customers.push(customersFromBooking[i]);
                    nbCustomers++;
                }
            }

            return nbCustomers + passageCustomersSale + passageCustomersBookingWithoutsale;
        };

        Day.prototype.getTotalFirstCustomers = function(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode){
            return this.getNbFirstCustomersOfSaleObject([RootStatCategorie], additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode);
        };

        Day.prototype.getLoyaltyCustomersOfSaleObject = function(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode)
        {
            if( (saleObjects[saleObjects.length - 1] === LoyaltyCustomers)){
                saleObjects = [HrRootCategory];
            }

            let customerFomSales = this.getSalesDatasOfSaleObject(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode).loyaltyCustormers,
                customersFromBooking = this.getBookingDatasOfBookingObject(saleObjects, additionalFilters, firstDayOfPeriod, taxMode).loyaltyCustormers;

            for(let i = 0; i < customersFromBooking.length; i++ ){
                if(customerFomSales.indexOf(customersFromBooking[i]) ===  -1){
                    customerFomSales.push(customersFromBooking[i]);
                }
            }

            return customerFomSales;
        };

        Day.prototype.getCustomersOfSaleObject = function(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode)
        {
            if( (saleObjects[saleObjects.length - 1] === LoyaltyCustomers)){
                saleObjects = [HrRootCategory];
            }

            let customerFomSales = this.getSalesDatasOfSaleObject(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode).customersSales,
                customersFromBooking = this.getBookingDatasOfBookingObject(saleObjects, additionalFilters, firstDayOfPeriod, taxMode).customersBookings;

            for(let i = 0; i < customersFromBooking.length; i++ ){
                if(customerFomSales.indexOf(customersFromBooking[i]) ===  -1){
                    customerFomSales.push(customersFromBooking[i]);
                }
            }
            return customerFomSales;
        };

        Day.prototype.getCustomersFirstOfSaleObject = function(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode)
        {
            if( (saleObjects[saleObjects.length - 1] === LoyaltyCustomers)){
                saleObjects = [HrRootCategory];
            }

            let customerFomSales = this.getSalesDatasOfSaleObject(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode).customersFirstSales,
                customersFromBooking = this.getBookingDatasOfBookingObject(saleObjects, additionalFilters, firstDayOfPeriod, taxMode).customersFirstBookings;

            for(let i = 0; i < customersFromBooking.length; i++ ){
                if(customerFomSales.indexOf(customersFromBooking[i]) ===  -1){
                    customerFomSales.push(customersFromBooking[i]);
                }
            }
            return customerFomSales;
        };

        Day.prototype.getNbPassageCustomersOfSaleObject = function(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode)
        {
            if( (saleObjects[saleObjects.length - 1] === LoyaltyCustomers)){
                saleObjects = [HrRootCategory];
            }

            let salesData = this.getSalesDatasOfSaleObject(saleObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode),
                nbPassageCustomersOfSaleWithoutBooking = salesData.nbPassageCustomersOfSaleWithoutBooking,
                nbPassageCustomersOfSaleWithBooking = salesData.nbPassageCustomersOfSaleWithBooking,
                nbPassageCustomersOfBookingWithoutSale = this.getBookingDatasOfBookingObject(saleObjects, additionalFilters, firstDayOfPeriod, taxMode).nbPassageCustomersOfBookingWithoutSale;

            return nbPassageCustomersOfSaleWithoutBooking + nbPassageCustomersOfSaleWithBooking + nbPassageCustomersOfBookingWithoutSale;
        };

        Day.prototype.getNbBookingsOfBookingObject = function(bookingObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode)
        {
            return this.getBookingDatasOfBookingObject(bookingObjects, additionalFilters, firstDayOfPeriod, taxMode).bookings.length;
        };

        Day.prototype.getBookingsCAOfBookingObject = function(bookingObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode)
        {
            return this.getBookingDatasOfBookingObject(bookingObjects, additionalFilters, firstDayOfPeriod, taxMode).price;
        };

        Day.prototype.getSubBookingsStepOfBookingObject = function(bookingObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode)
        {
            return this.getBookingDatasOfBookingObject(bookingObjects, additionalFilters, firstDayOfPeriod, taxMode).subBookingsStep;
        };

        Day.prototype.getBookingsOfBookingObject = function(bookingObjects, additionalFilters, firstDayOfPeriod, lastDayOfPeriod, taxMode)
        {
            return this.getBookingDatasOfBookingObject(bookingObjects, additionalFilters, firstDayOfPeriod, taxMode).bookings;
        };

        Day.prototype.getBookingDatasOfBookingObject = function(bookingObjects, additionalFilters, firstDayOfPeriod, taxMode) {
            let bookingDatas = null,
                keyOfSaleObjects = this.getKeyOfSaleObjects(bookingObjects, additionalFilters, firstDayOfPeriod, taxMode);

            if(this.precalculatedBookingStatDatas[keyOfSaleObjects] !== undefined && moment().startOf('day').isAfter(this.getMomentDate())){
                bookingDatas = this.precalculatedBookingStatDatas[keyOfSaleObjects];
            }
            else {
                bookingDatas = {
                    bookings : [],
                    subBookings : [],
                    subBookingsStep : [],
                    price : 0,
                    loyaltyCustormers : [],
                    customers : [],
                    customersFirstVisit : [],
                    customersBookings : [],
                    customersFirstBookings : [],
                    customersFirstBookingsOfBookingObject : [],
                    matchedBookingsOfPassageCustomer : [],
                    nbPassageCustomersOfBookingWithoutSale : 0,
                    humanRessource : null
                };

                for (let i = 0; i < this.bookings.length; i++) {
                    if (this.bookings[i].bookingServices.length > 0) {
                        for (let j = 0; j < this.bookings[i].bookingServices.length; j++) {
                            if(this.bookings[i].bookingServices[j].isPackage && this.bookings[i].bookingServices[j].subBookingServices.length>0){
                                for (let k = 0; k < this.bookings[i].bookingServices[j].subBookingServices.length; k++) {
                                    this.bookings[i].bookingServices[j].subBookingServices[k].incrementBookingDatas(bookingDatas, bookingObjects, additionalFilters, firstDayOfPeriod, taxMode, this);
                                }
                            }
                            else{
                                this.bookings[i].bookingServices[j].incrementBookingDatas(bookingDatas, bookingObjects, additionalFilters, firstDayOfPeriod, taxMode, this);
                            }
                        }
                    }
                }

                for(let i = 0; i < bookingDatas.matchedBookingsOfPassageCustomer.length; i++){
                    if(bookingDatas.matchedBookingsOfPassageCustomer && bookingDatas.matchedBookingsOfPassageCustomer[i]) {
                        if(!bookingDatas.matchedBookingsOfPassageCustomer[i].sale){
                            bookingDatas.nbPassageCustomersOfBookingWithoutSale++;
                        }
                    }
                }
                this.precalculatedBookingStatDatas[keyOfSaleObjects] = bookingDatas;
            }
            return bookingDatas;
        };

        Day.prototype.getOccupationDatasOfHrObject = function(hrObjects){
            let lastHrObject = hrObjects[hrObjects.length -1],
                timeOfHrObject = null,
                occupationDatas;

            for(let i = 0; i < hrObjects.length; i++ ){
                if(hrObjects[i] instanceof HumanResource){
                    occupationDatas = this.getHrOccupationDatas([hrObjects[i]]);
                    break;
                }
            }

            if(lastHrObject instanceof HumanResource){
                timeOfHrObject = occupationDatas.bookingTime + occupationDatas.unoccupiedTime + occupationDatas.usualIndisponibilityTime + occupationDatas.unusualIndisponibilityTime
            }
            else if(lastHrObject === WorkingTimeHrIndisponibilityTime){
                timeOfHrObject = occupationDatas.usualIndisponibilityTime + occupationDatas.unusualIndisponibilityTime
            }
            else if(lastHrObject === WorkingTimeHrUnusualIndisponibilityTime){
                timeOfHrObject = occupationDatas.unusualIndisponibilityTime
            }
            else if(lastHrObject === WorkingTimeHrUsualIndisponibilityTime){
                timeOfHrObject = occupationDatas.usualIndisponibilityTime
            }
            else if(lastHrObject === WorkingTimeHrBookingOpenTime){
                timeOfHrObject = occupationDatas.workingTime;
            }
            else if(lastHrObject === WorkingTimeHrUnoccupiedTime){
                timeOfHrObject = occupationDatas.unoccupiedTime;
            }
            else if(lastHrObject === WorkingTimeHrBookingTime){
                timeOfHrObject = occupationDatas.bookingTime;
            }
            return timeOfHrObject;
        };

        Day.prototype.getBookingTimeOfHrObject = function(hrObjects){
            return this.getHrOccupationDatas(hrObjects).bookingTime;
        };

        Day.prototype.getWorkingTimeOfHrObject = function(hrObjects){
            return this.getHrOccupationDatas(hrObjects).workingTime;
        };

        Day.prototype.getHrOccupationPrimaryDatas = function(hrObjects){
            let occupationDatas = this.getHrOccupationDatas(hrObjects);

            for(let i = 0; i < hrObjects.length; i++ ){
                if(hrObjects[i] instanceof HumanResource){
                    occupationDatas = this.getHrOccupationDatas([hrObjects[i]]);
                    break;
                }
            }

           return occupationDatas?new HrOccupationDatas(this, occupationDatas.unoccupiedTime, occupationDatas.bookingTime, occupationDatas.unusualIndisponibilityTime, occupationDatas.usualIndisponibilityTime):null;
        };

        Day.prototype.getHrOccupationDatas = function(hr) {
            let occupationRateData = null,
                targetHr = null,
                bookingTime = 0,
                workingTime = 0,
                unusualIndisponibilityTime = 0,
                usualIndisponibilityTime = 0;

            //in order to use this function in report, the function must accept a table in parameter
            if (hr instanceof Array) {
                targetHr = hr[hr.length - 1];
            }
            else {
                targetHr = hr;
            }

            let keyOfHr = targetHr.id;

            if (this.precalculatedHrOccupationDatas[keyOfHr] !== undefined && moment().startOf('day').isAfter(this.getMomentDate())) {
                occupationRateData = this.precalculatedHrOccupationDatas[keyOfHr];
            }
            else {
                let humanRessources = HumanResourceData.getActiveList();

                for (let j = 0; j < humanRessources.length; j++) {
                    if( targetHr === HrRootOccupationRateCategory ||
                        targetHr === WorkingTimeRootCategory ||
                        targetHr === humanRessources[j] ) {
                        let hrLoop = humanRessources[j];

                        if (this.hrIsWorking(hrLoop.id) && hrLoop.hasPlanning) {
                            bookingTime += this.getHrBookingTime(hrLoop.id);
                            workingTime += this.getHrWorkingTime(hrLoop.id);
                            usualIndisponibilityTime += this.getHrUsualIndisponibilityTime(hrLoop.id);
                            unusualIndisponibilityTime += this.getHrUnusualIndisponibilityTime(hrLoop.id);
                        }
                    }
                }

                occupationRateData = {
                    "bookingTime" : bookingTime,
                    "workingTime" : workingTime,
                    "unoccupiedTime" : workingTime - bookingTime,
                    "unusualIndisponibilityTime" : unusualIndisponibilityTime,
                    "usualIndisponibilityTime": usualIndisponibilityTime
                };

                this.precalculatedHrOccupationDatas[keyOfHr] = occupationRateData;
            }

            return occupationRateData;
        };

        Day.prototype.getBookingTimeOfPrObject = function(prObjects){
            return this.getPrOccupationDatas(prObjects).bookingTime;
        };

        Day.prototype.getWorkingTimeOfPrObject = function(prObjects){
            return this.getPrOccupationDatas(prObjects).workingTime;
        };

        Day.prototype.getPrOccupationDatas = function(hr) {
            let occupationRateData = null,
                targetPr = null,
                bookingTime = null,
                workingTime = null;

            //in order to use this function in report, the function must accept a table in parameter
            if (hr instanceof Array) {
                targetPr = hr[hr.length - 1];
            }
            else {
                targetPr = hr;
            }

            let keyOfPr = targetPr.id;

            if (this.precalculatedPrOccupationDatas[keyOfPr] !== undefined && moment().startOf('day').isAfter(this.getMomentDate())) {
                occupationRateData = this.precalculatedPrOccupationDatas[keyOfPr];
            }
            else {
                let physicalRessources = PhysicalResourceData.getActiveList();

                for (let j = 0; j < physicalRessources.length; j++) {
                    let prLoop = physicalRessources[j];

                    for (let k = 1; k <= prLoop.number; k++) {
                        if( targetPr === PrRootOccupationRateCategory ||
                            prLoop === targetPr) {
                            let prLoop = physicalRessources[j];

                            if (this.prIsWorking(prLoop.id, k) && prLoop.hasPlanning) {
                                bookingTime += this.getPrBookingTime(prLoop.id, k);
                                workingTime += this.getPrWorkingTime(prLoop.id, k);
                            }
                        }
                    }
                }
                occupationRateData = {
                    "bookingTime" : bookingTime,
                    "workingTime" : workingTime
                };

                this.precalculatedPrOccupationDatas[keyOfPr] = occupationRateData;
            }
            return occupationRateData;
        };

        Day.prototype.getSalesServicesByHrId = function(hrId)
        {
            var salesItems = [];
            for (var j = 0; j < this.sales.length; j++) {
                salesItems = salesItems.concat(this.sales[j].getSalesServicesByHrId(hrId));
            }
            return salesItems;
        };

        Day.prototype.getSalesProductsByHrId = function(hrId)
        {
            var salesItems = [];
            for (var j = 0; j < this.sales.length; j++) {
                salesItems = salesItems.concat(this.sales[j].getSalesProductsByHrId(hrId));
            }
            return salesItems;
        };

        Day.prototype.getBookingsSumPriceByHrId = function(hrId)
        {
            var result  = {ca:0,nbBookings:0};
            for (var j = 0; j < this.bookings.length; j++) {
                if (this.bookings.status!="notCame")
                    for (var k = 0; k < this.bookings[j].bookingServices.length; k++) {
                            if (this.bookings[j].bookingServices[k].dayHr && this.bookings[j].bookingServices[k].dayHr.humanResourceId === hrId) {
                                result.ca += this.bookings[j].bookingServices[k].price;
                                result.nbBookings++;
                            }
                    }
            }
            return result;
        };

        Day.prototype.getSalesSumPriceByHrId = function(hrId,withGift)
        {
            var result  =
                {ca:0,
                    caServices :0,
                    caProducts :0,
                    caGiftItems :0,
                    caCures :0,
                    caLoyaltyCards :0,
                nbSales:0};
            var saleServicesPrice,saleProductsPrice,saleGiftItemsPrice,saleCuresPrice,loyaltyCardItemsPrice;
            for (var j = 0; j < this.sales.length; j++) {
                saleServicesPrice = this.sales[j].getSaleServicesSumPriceByHrId(hrId,withGift);
                saleProductsPrice = this.sales[j].getSaleProductsSumPriceByHrId(hrId,withGift);
                saleGiftItemsPrice = this.sales[j].getSaleGiftItemsSumPriceByHrId(hrId,withGift);
                saleCuresPrice = this.sales[j].getSaleCuresSumPriceByHrId(hrId,withGift);
                loyaltyCardItemsPrice = this.sales[j].getLoyaltyCardItemsSumPriceByHrId(hrId,withGift);
                if (saleServicesPrice!=0 || saleProductsPrice!=0|| saleGiftItemsPrice!=0|| saleCuresPrice!=0|| loyaltyCardItemsPrice!=0)    {
                    result.caServices += saleServicesPrice;
                    result.caProducts += saleProductsPrice;
                    result.caGiftItems += saleGiftItemsPrice;
                    result.caCures += saleCuresPrice;
                    result.caLoyaltyCards += loyaltyCardItemsPrice;
                    result.nbSales++;
                }
            }
            result.ca = result.caServices + result.caProducts + result.caCures+ result.caLoyaltyCards;   //no giftitem
            return result;
        };
        Day.prototype.getNumberOfCustomers = function(dateTime)
        {
            var customers = [];
            if(dateTime !== undefined) // if we want to get an average value in future
            {}
            else
            {
                var customerAlreadyListed = false;
                for (var i=0; i<this.bookings.length; i++)
                {
                    customerAlreadyListed = false;
                    for(var j=0; j<customers.length; j++)
                        if(this.bookings[i].customer && customers[j].id === this.bookings[i].customer.id) {
                            customerAlreadyListed = true;
                            break;
                        }
                    if(!customerAlreadyListed && this.bookings[i].customer) {
                        customers.push(this.bookings[i].customer);
                    }
                }
                for (var i=0; i<this.sales.length; i++)
                {
                    customerAlreadyListed = false;
                    for(var j=0; j<customers.length; j++)
                        if(this.sales[i].customer && customers[j].id === this.sales[i].customer.id) {
                            customerAlreadyListed = true;
                            break;
                        }
                    if(!customerAlreadyListed && this.sales[i].customer) {
                        customers.push(this.sales[i].customer);
                    }
                }
            }

            return customers.length;
        };

        Day.prototype.getDate = function()
        {
            //assume id is like
            var date = null;
            if (this.id>0)
            {
                var ids = this.id.toString();
                var year = ids.substring(0,4);
                var month = ids.substring(4,6);
                var day = ids.substring(6);
                date = new Date(year + '/' + month + '/' + day);
            }
            return date;
        };
        Day.prototype.getMomentDate = function()
        {
            //assume id is like
            var date = null;
            if (this.id>0)
            {
                var ids = this.id.toString();
                var year = ids.substring(0,4);
                var month = ids.substring(4,6);
                var day = ids.substring(6);
                // date = moment(new Date(year + '/' + month + '/' + day));
                date = moment().year(year).month(parseInt(month)-1).date(day).startOf('day');    // for .month() need to pass an int and january is 0, not 1
            }
            return date;
        };
        Day.prototype.getWeekday = function()
        {
            return this.getMomentDate().weekday();
        };
        Day.prototype.hasPosOp = function(type,status)
        {
            for (var i = 0; i <this.posOps.length; i++)
                if (this.posOps[i].type==type && this.posOps[i].status==status)
                    return true;
            return false;
        };
        Day.prototype.getCashAmount = function()
        {
            var cashAmount = 0;
            for (var i = 0; i <this.sales.length; i++)
                if ( this.sales[i].status=="sold"|| this.sales[i].status=="credit" || this.sales[i].status=="canceled")
                    cashAmount += this.sales[i].getCashAmount();
            return cashAmount;
        };
        Day.prototype.getPosOpsAmount = function()
        {
            var amount = 0;
            for (var i = 0; i <this.posOps.length; i++)
                if (this.posOps[i].status=="validate")
                amount += this.posOps[i].amount;
            return amount;
        };
        Day.prototype.getDayName = function()
        {
            var dayName = "";
            switch(this.getWeekday()) {
                case 0 :
                {
                    dayName = 'dimanche';
                    break;
                }
                case 1 :
                {
                    dayName = 'lundi';
                    break;
                }
                case 2 :
                {
                    dayName = 'mardi';
                    break;
                }
                case 3 :
                {
                    dayName = 'mercredi';
                    break;
                }
                case 4 :
                {
                    dayName = 'jeudi';
                    break;
                }
                case 5 :
                {
                    dayName = 'vendredi';
                    break;
                }
                case 6 :
                {
                    dayName = 'samedi';
                    break;
                }
                default :
                {
                    dayName = 'null';
                    break;
                }
            }
            return dayName;
        };

        Day.prototype.calculateMaxPeriod = function(period) {
            for (let k = 0; k < this.dayHrs.length; k++) {
                this.dayHrs[k].calculateMaxPeriod(period);
            }
            for (let k = 0; k < this.dayPrs.length; k++) {
                this.dayPrs[k].calculateMaxPeriod(period);
            }
        };

        return Day;
    }
    ]);

angular.module('FlexyBeautyApp.services')
.factory('DaySrv',["$log","$timeout","Day_Resource","Day","DayData","BookingSrv","DateSrv","Decorators","TimeMeasures","Constants","moment",
function ($log,$timeout,Day_Resource,Day,DayData,BookingSrv,DateSrv,Decorators,TimeMeasures,Constants,moment) {
    var  daySrv = {lastReceivedDate : null,promise:null};

    daySrv.getIdFromDate = function(date)
    {
        //Get id from date : YYYYMMDD format
        if (date)
            return date.getFullYear()*10000+(date.getMonth()+1)*100+date.getDate();
        return null;

    };

    daySrv.getDateFromId = function (id) {
        let date = null;
        if (id > 0) {
            let ids = id.toString();
            let year = ids.substring(0, 4);
            let month = ids.substring(4, 6);
            let day = ids.substring(6);
            date = new Date(year +'/' + month + '/' + day);
        }
        return date;
    };

    daySrv.get = function(dayId,successFunction,errorFunction)
    {
        Day_Resource.get(
            {id:dayId}, //params
            function (data) {
                if (successFunction!== undefined)
                    successFunction(data);

            },
            function (data) {
                $log.error(data);
                if (errorFunction!== undefined)
                    errorFunction(data);
            });
    };
    daySrv.bookingLoaded = function(successFunction)
    {
         var allLoaded = true;
         for (var i =0;i< DayData.indexDays.length&&allLoaded;i++)
             allLoaded = (DayData.indexDays[i].bookings!=null)
         if (allLoaded && successFunction!== undefined)
             successFunction();
    };
    daySrv.query = function(startDayId,successFunction,errorFunction)
    {
        //Day_Resource.query(
        if (!startDayId)
            startDayId = 20000101;
        Day_Resource.getDays(
            {startId:startDayId,endId:30000101}, //get all days
            function (data) {   //success
                var day;
                if (successFunction!== undefined)
                    successFunction(data);//WILL CALL daySrv.loadResourceDays

            },
            function (data) {
                $log.error(data);
                if (errorFunction!== undefined)
                    errorFunction(data);
            }
        );

    };
    daySrv.queryBasedDays = function(startDayId,endId)
    {
        if (!startDayId)
            startDayId = 20000101;
        return Day_Resource.getDays({startId:startDayId,endId:endId}).$promise;
    };

    daySrv.listDaysId = function()
    {
        return Day_Resource.listDaysId({}).$promise;
    };

    daySrv.getFirstDateOfWeek = (dayId) => {
        let date = daySrv.getDateFromId(dayId);
        let dayOfWeek = date.getDay() - 1;
        if (dayOfWeek === -1) {
            dayOfWeek = 6;
        }

        return new Date(date.setDate(date.getDate() - dayOfWeek));
    };

    daySrv.getLastDateOfWeek = (dayId) => {
        let date = daySrv.getDateFromId(dayId);
        let lastDay = date.getDate() - date.getDay() + 7;

        return new Date(date.setDate(lastDay));
    };

    daySrv.newLoadResourceDays = Decorators.timeMeasureDecorator(
        function(resourceDaysMap, isApplicationLoading, startupDaysMap){

            if (resourceDaysMap) {
                // FiXME at minimum one Day is created in order to avoid null error in views loading
                let tomorrow = new Date();
                tomorrow.setDate(tomorrow.getDate() + 1);

                const dayKeys = Object.keys(resourceDaysMap);

                const firstDay = resourceDaysMap[dayKeys[0]];
                let firstDate = firstDay ? daySrv.getFirstDateOfWeek(firstDay.id) : new Date();

                const lastDay = resourceDaysMap[dayKeys[dayKeys.length - 1]];
                let lastDate = lastDay ? daySrv.getLastDateOfWeek(lastDay.id) : tomorrow;

                if(startupDaysMap) {
                    const startupDayKeys = Object.keys(startupDaysMap);
                    const firstStartupDay = startupDaysMap[startupDayKeys[0]];
                    let firstStartupDate = firstStartupDay ? daySrv.getFirstDateOfWeek(firstStartupDay.id) : new Date();

                    if(lastDate.getTime() < firstStartupDate.getTime()) {
                        lastDate =  firstStartupDate;
                    }
                }

                let firstMoment = moment(firstDate);
                let lastMoment = moment(lastDate);

                let nbDaysToCreate = lastMoment.diff(firstMoment, 'days');

                for (let i = 0; i <= nbDaysToCreate; i++) {
                    let currentDate = new Date(firstDate);
                    currentDate.setDate(currentDate.getDate() + i);
                    const id = daySrv.getIdFromDate(currentDate);
                    const dayToLoad = resourceDaysMap[id];

                    if (dayToLoad) {
                        let existingDay = DayData.getById(id, isApplicationLoading);
                        if (!existingDay) {
                            let day = new Day(dayToLoad, isApplicationLoading);
                            DayData.add(day, isApplicationLoading);
                        } else {
                            existingDay.loadObject(dayToLoad, isApplicationLoading)
                        }
                    } else {
                        let day = new Day(null, isApplicationLoading);
                        day.id = id;
                        DayData.add(day, isApplicationLoading);
                    }
                }
            }
        },
        TimeMeasures.RESOURCE_DAYS_LOADING
    );

    daySrv.loadResourceDays = Decorators.timeMeasureDecorator(
            function(resourceDays, isApplicationLoading){
                if (resourceDays) {
                    var today = new Date();
                    var diff = today.getDate() - today.getDay() +1-28;
                    var firstDayDate = new Date(today.setDate(diff));//Start on monday
                    var firstDayId =  daySrv.getIdFromDate(firstDayDate);
                    var lastDayDate = new Date(firstDayDate);
                    lastDayDate.setDate(lastDayDate.getDate() + 139);//load at least 140 days (20 weeks)
                    var lastDayId = daySrv.getIdFromDate(lastDayDate);
                    var iDate;
                    var continueAdding = true;
                    var day;
                    if (resourceDays.length>0 && resourceDays[0]!=undefined && resourceDays[resourceDays.length-1]!=undefined)//days exist
                    {
                        if (resourceDays[0].id<firstDayId)//first day on server is older that monday of current week : use it as start
                        {
                            firstDayDate = daySrv.getDateFromId(resourceDays[0].id);
                            diff = (firstDayDate.getDate() - firstDayDate.getDay() + 1) - 7;
                            firstDayDate = new Date(firstDayDate.setDate(diff));//Start on monday
                        }
                        if (resourceDays[resourceDays.length-1].id>lastDayId)//last day on server is more in futur than 20 weeks in future : use it
                        {
                            lastDayDate = daySrv.getDateFromId(resourceDays[resourceDays.length-1].id);
                            diff = lastDayDate.getDate() - lastDayDate.getDay() + 7;
                            lastDayDate = new Date(lastDayDate.setDate(diff));//end on sunday
                            lastDayId = daySrv.getIdFromDate(lastDayDate);
                        }
                    }
                    for (var d = 0; continueAdding && d <10000 ; d++) {//security loop
                        iDate = new Date(firstDayDate);
                        iDate.setDate(iDate.getDate() + d);
                        day = new Day(null, isApplicationLoading);
                        day.id = this.getIdFromDate(iDate);
                        DayData.add(day, isApplicationLoading);
                        var found = false;
                        var i;
                        for (i = 0; i < resourceDays.length && !found; i++) {
                            if(resourceDays[i]!=undefined && resourceDays[i].id==day.id)
                            {
                                day.loadObject(resourceDays[i], isApplicationLoading);
                                resourceDays.splice(i,1);//remove from resourcedays
                                found = true;
                            }
                        }
                        if (day.id ==lastDayId)
                            continueAdding = false;
                    }
                }
            },
            TimeMeasures.RESOURCE_DAYS_LOADING
    );
    daySrv.addDays = function(firstDate,nbdaysToLoad,insertBefore,successFunction,errorFunction)
    {
        var diff = firstDate.getDate() - firstDate.getDay() +1;
        var dayOfWeekDate = new Date(firstDate.setDate(diff));//Start on monday
        var dayId=this.getIdFromDate(dayOfWeekDate)
        var date;
        var day;
        for (var d=0;d<nbdaysToLoad;d++)
        {
            day = new Day();
            date =  new Date(dayOfWeekDate);
            date.setDate(date.getDate() + d);
            day.id = this.getIdFromDate(date);
            if (insertBefore)
                DayData.insertAt(day,d);
            else
                DayData.add(day);
        }
    }

    daySrv.getByIdAdder = function(dayId)
    {
        if (DayData.indexDays && DayData.indexDays.length!=0)
            if (DayData.indexDays[DayData.indexDays.length-1].id<dayId)
            {
                var dayIndexStart =   DayData.indexDays.length + DateSrv.daysBetween(daySrv.getDateFromId(DayData.indexDays[DayData.indexDays.length-1].id),daySrv.getDateFromId(dayId));
                daySrv.addWeeks(dayIndexStart);
            }
            else
                if (DayData.indexDays[0].id>dayId)
                {
                    var dayIndexStart =  - DateSrv.daysBetween(daySrv.getDateFromId(DayData.indexDays[0].id),daySrv.getDateFromId(dayId));
                    daySrv.addWeeks(dayIndexStart);
                }
        return DayData.getById(dayId);
    }
    daySrv.addWeeks = function(dayIndexStart)
    {
        if (DayData.indexDays.length === 0) {
            return 0;
        }

        var day,date,refDay,refDate,nbdaysToLoad;
        //add a complete week do data model days

        if (dayIndexStart<0)//
        {
            nbdaysToLoad =  Math.ceil(-dayIndexStart/7)*7;//round to a week
            refDay = DayData.indexDays[0];
            refDate = refDay.getDate();
            for (var d=1;d<=nbdaysToLoad;d++)
            {
                day = new Day();
                date =  new Date(refDate);
                date.setDate(date.getDate() - d);
                day.id = this.getIdFromDate(date);
                DayData.insertAt(day,0);
                dayIndexStart++;
            }
        }
        else
        {
            nbdaysToLoad =  Math.ceil(dayIndexStart/7)*7+7 -DayData.indexDays.length;//round to a week
            refDay = DayData.indexDays[DayData.indexDays.length-1];
            refDate = refDay.getDate();
            for (var d=1;d<=nbdaysToLoad;d++)
            {
                day = new Day();
                date =  new Date(refDate);
                date.setDate(date.getDate() + d);
                day.id = this.getIdFromDate(date);
                DayData.add(day);
            }
        }
        return dayIndexStart;

    }
    daySrv.getDays = function(firstDate,nbdaysToLoad,insertBefore,successFunction,errorFunction)
    {
        daySrv.addDays(firstDate,nbdaysToLoad,insertBefore,successFunction,errorFunction);
        Day_Resource.getDays(
            {startId:DayData.indexDays[0].id,endId:DayData.indexDays[DayData.indexDays.length-1].id}, //get period
            function (data) {
                daySrv.lastReceivedDate = new Date(data.queryDate);
                if (successFunction!== undefined)
                    successFunction(data);

            },
            function (data) {
                $log.error(data);
                if (errorFunction!== undefined)
                    errorFunction(data);
            });

    };

    daySrv.loadExistingResourceDays= function(resourceDays)
    {
        var day;
        if (resourceDays)
            for (var i=0;i<resourceDays.length;i++)
            {
                day = DayData.getById(resourceDays[i].id);
                if (day)
                    day.loadObject(resourceDays[i]);
            }
    };

    daySrv.computeDayData = function(firstDate,nbdaysToLoad) {
        let day = firstDate.getDay();
        let dayOfWeekDiff = day === 0 ? -6 : 1;
        let diff = firstDate.getDate() - day + dayOfWeekDiff;
        let dayOfWeekDate = new Date(firstDate.setDate(diff));//Start on monday
        let date;
        DayData.clear();//clear days every time to be sur to have an up to date data
        for (let d=0;d<nbdaysToLoad;d++)
        {
            day = new Day();
            date =  new Date(dayOfWeekDate);
            date.setDate(date.getDate() + d);
            day.id = this.getIdFromDate(date);
            DayData.add(day);
        }
    }

    daySrv.getAvailablePeriods = function(firstDate,nbdaysToLoad,isNextWeek,successFunction,errorFunction)
    {
        this.computeDayData(firstDate,nbdaysToLoad);
        if(daySrv.availablePeriodRequest) {
            daySrv.availablePeriodRequest.$cancelRequest();
        }
        daySrv.availablePeriodRequest = Day_Resource.getAvailablePeriods(
            {startId: DayData.indexDays[0].id, endId: DayData.indexDays[DayData.indexDays.length - 1].id, isNextWeek: isNextWeek}, //get period
            function (data) {
                let day;
                let loadedDays = [];
                let nextDayId = data.dayAvailablePeriodsInterfaces[0] != null ? data.dayAvailablePeriodsInterfaces[0].id : DayData.indexDays[0].id;
                let nextDay = moment(nextDayId, "YYYYMMDD").toDate();
                daySrv.computeDayData(nextDay,7,false);
                for (let dayAvailablePeriodsInterface of data.dayAvailablePeriodsInterfaces) {
                    day = DayData.getById(dayAvailablePeriodsInterface.id);
                    loadedDays.push(day);
                    if (day) {
                        day.loadObject(dayAvailablePeriodsInterface);
                    }
                }
                if (successFunction!== undefined) {
                    successFunction(loadedDays, null, nextDay, isNextWeek);
                }
                daySrv.availablePeriodRequest = null;

            },
            function (data) {
                $log.error(data);

                if (errorFunction !== undefined) {
                    errorFunction(data);
                }
                if(data.xhrStatus !== "abort") {
                    daySrv.availablePeriodRequest = null;
                }
            });

    };

    return daySrv;
}]);

angular.module('FlexyBeautyApp.services').
    factory('DayData',["$log","ModelDataUtil", function ($log,ModelDataUtil)
    {
        var  dayData = {
            objDays : {},
            indexDays : []
        };
        dayData.getById =  function(dayId, isApplicationLoading)
        {
            let day = null;
            if(isApplicationLoading){
                day = this.objDays[dayId];
            }
            else {
                for (let i = 0; i < this.indexDays.length; i++){
                    if (this.indexDays[i].id == dayId) {
                        day = this.indexDays[i];
                        break;
                    }
                }
            }
            return day;
        };

        dayData.getIndexOf =  function(day)
        {
            if (day)
                return this.indexDays.indexOf(day);
            return -1;
        }
        dayData.getByIndex =  function(index)
        {
            if (index>=0 && index <this.indexDays.length)
                return this.indexDays[index];
            return null;
        }
        dayData.add =  function(day, isApplicationLoading)
        {
            if(isApplicationLoading){
                if(day && day.id)
                    this.objDays[day.id] = day;
            }
            else {
                this.indexDays.push(day);
            }
        };
        dayData.insertAt =  function(day,index)
        {
            this.indexDays.splice(index, 0,day);
            return this.indexDays.length-1;
        }
        dayData.insert =  function(day)
        {
            for (var i=0;i<this.indexDays.length;i++)
                if (this.indexDays[i].id > day.id)
                {
                    this.indexDays.splice(i, 0,day);
                    return i;
                }
            this.indexDays.push(day);
            return this.indexDays.length-1;
        }

        dayData.clear =  function()
        {
            this.indexDays = [];
            this.objDays = {};
        }
        dayData.getActiveList =  function()
        {
            return this.indexDays;
        }
        dayData.isLoaded =  function()
        {
            return this.indexDays.length!=0;
        };
        dayData.getOpenDay =  function(index)
        {
            for (var i=0;i<this.indexDays.length;i++)
                if (index!= i && this.indexDays[i].closure && this.indexDays[i].closure.status=="open")
                    return this.indexDays[i];

            return null;
        }
        dayData.getOpenDayByLast =  function()
        {
            for (var i=this.indexDays.length-1;i>=0;i--)
                if (this.indexDays[i].closure && this.indexDays[i].closure.status=="open")
                    return this.indexDays[i];

            return null;
        }
        dayData.getLastClosedDay =  function()
        {
            for (var i=this.indexDays.length-1;i>=0;i--)
                if (this.indexDays[i].closure && this.indexDays[i].closure.status=="closed")
                    return this.indexDays[i];

            return null;
        };
        dayData.calculateMaxPeriod = function(period)
        {
            for (var i=0;i<this.indexDays.length;i++)
            {
                this.indexDays[i].calculateMaxPeriod(period);
            }
        };

        dayData.convertMapToArray = function(keepObject, isNewLoading){
            if (isNewLoading) {
                this.indexDays = ModelDataUtil.convertObjectToArray(this.objDays, this.indexDays);
                this.indexDays.sort((day1, day2) => day1.id - day2.id);
                if (!keepObject) {
                    this.objDays = {};
                }
            } else {
                this.indexDays = ModelDataUtil.convertMapToArray(this.objDays, this.indexDays);
                this.objDays = null;
            }
        };

        return dayData;
    }
    ]);



// WEBPACK FOOTER //
// ./js/services/models/Day.js